import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { company, pdfFlowsUrl } from '../data/site';

const sections = [
  {
    title: 'Who We Are',
    body: [
      `This website is operated by ${company.legalName} ("Market Fusion Innovations", "we", "us" or "our"), a company with its registered office at ${company.address}. We are the controller of personal data processed through this website.`,
      `This policy covers ${company.domain} only. Our products have their own privacy policies — for example, PDF Flows is covered by the policy published at ${pdfFlowsUrl}/privacy.`,
    ],
  },
  {
    title: 'Information We Collect',
    body: [
      'We aim to collect as little personal data as possible. This website has no user accounts, no contact forms that store data, and no advertising trackers.',
      [
        'Information you send us: if you email us, we receive your email address, name (if provided) and the content of your message.',
        'Technical data: like any website, our hosting provider automatically processes basic request data such as IP address, browser type, device type, referring page and the date and time of your visit, for security and to deliver the site.',
      ],
    ],
  },
  {
    title: 'How We Use Information',
    body: [
      [
        'To respond to your enquiries and communicate with you',
        'To operate, secure and maintain the website, including detecting abuse and technical faults',
        'To comply with legal obligations and enforce our rights',
      ],
      'We do not sell your personal data, and we do not use it for automated decision-making or profiling.',
    ],
  },
  {
    title: 'Legal Bases for Processing',
    body: [
      'Where data protection laws such as the Law of Ukraine "On Personal Data Protection" or the EU General Data Protection Regulation (GDPR) apply, we process personal data on the following bases:',
      [
        'Legitimate interests — to run a secure website and reply to messages you send us',
        'Legal obligation — where we must retain or disclose information by law',
        'Consent — where you have given it, which you may withdraw at any time',
      ],
    ],
  },
  {
    title: 'Cookies and Third-Party Services',
    body: [
      'This website does not set advertising or analytics cookies. It may use strictly necessary browser storage required for the site to function.',
      'To display our typography, the website loads fonts from Google Fonts, which means your browser connects to Google servers and shares your IP address with Google. Please refer to Google’s privacy policy for details. Links to external websites, including pdf-flows.com, are governed by those websites’ own policies.',
    ],
  },
  {
    title: 'Sharing of Information',
    body: [
      'We share personal data only where necessary, with:',
      [
        'Service providers who host the website or provide email services on our behalf, under appropriate confidentiality obligations',
        'Professional advisers, authorities or courts where required by law or to protect our legal rights',
        'A successor entity in the event of a merger, acquisition or sale of assets, subject to this policy',
      ],
    ],
  },
  {
    title: 'International Transfers',
    body: [
      'Our service providers may process data outside Ukraine. Where we transfer personal data internationally, we take reasonable steps to ensure it receives an adequate level of protection, such as relying on providers that offer appropriate contractual safeguards.',
    ],
  },
  {
    title: 'Data Retention',
    body: [
      'We keep email correspondence for as long as needed to handle your enquiry and any follow-up, and for up to 24 months afterwards unless a longer period is required by law. Technical server logs are kept by our hosting provider for a limited period for security purposes.',
    ],
  },
  {
    title: 'Your Rights',
    body: [
      'Depending on where you live, you may have the right to:',
      [
        'Access the personal data we hold about you',
        'Request correction of inaccurate data',
        'Request deletion of your data',
        'Object to or restrict certain processing',
        'Receive your data in a portable format',
        'Withdraw consent where processing is based on consent',
        'Lodge a complaint with a supervisory authority, such as the Ukrainian Parliament Commissioner for Human Rights or your local data protection authority',
      ],
      `To exercise any of these rights, email ${company.email}. We will respond within the time required by applicable law.`,
    ],
  },
  {
    title: 'Security',
    body: [
      'We use appropriate technical and organisational measures to protect personal data, including encrypted (HTTPS) connections. No method of transmission over the internet is completely secure, however, and we cannot guarantee absolute security.',
    ],
  },
  {
    title: 'Children',
    body: [
      'This website is not directed at children under 16, and we do not knowingly collect personal data from them. If you believe a child has sent us personal data, please contact us and we will delete it.',
    ],
  },
  {
    title: 'Changes to This Policy',
    body: [
      'We may update this Privacy Policy from time to time. The latest version will always be published on this page with its "Last updated" date.',
    ],
  },
  {
    title: 'Contact Us',
    body: [
      'If you have any questions about this Privacy Policy or how we handle personal data, contact us:',
      [`By email: ${company.email}`, `By post: ${company.legalName}, ${company.address}`],
    ],
  },
];

export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      updated="October 2026"
      intro={`This Privacy Policy explains how ${company.legalName} collects, uses and protects personal information when you visit ${company.domain}.`}
      sections={sections}
    />
  );
}
